import React from 'react';
import { Grid, Header3Text } from 'ui-toolkit';
import { IFeeSection } from './organizeFees';
import { PurchaseFeeSection } from './PurchaseFeeSection';

export interface IPurchaseFeesProps {
  feeSections: IFeeSection[];
}

export const PurchaseFees: React.FC<IPurchaseFeesProps> = ({ feeSections }) => {
  const sectionK = feeSections.find((t) => t.sectionDefinition.sectionLetter === 'K');
  const sectionL = feeSections.find((t) => t.sectionDefinition.sectionLetter === 'L');
  const sectionM = feeSections.find((t) => t.sectionDefinition.sectionLetter === 'M');
  const sectionN = feeSections.find((t) => t.sectionDefinition.sectionLetter === 'N');

  const sectionCashFromBuyer = feeSections.find(
    (t) => t.sectionDefinition.sectionDescription === 'Cash To Close From Buyer'
  );
  const sectionCashToSeller = feeSections.find((t) => t.sectionDefinition.sectionDescription === 'Cash To Seller');

  return (
    <Grid>
      <Grid columnCount={2}>
        <Header3Text>Buyer's transaction at closing</Header3Text>
        <Header3Text>Seller's transaction at closing</Header3Text>
      </Grid>
      {sectionK && sectionM && (
        <PurchaseFeeSection
          leftSection={sectionK}
          rightSection={sectionM}
          subLabel={`Adjustments For Items Paid By Seller In Advance`}
        />
      )}
      {sectionL && sectionN && (
        <PurchaseFeeSection
          leftSection={sectionL}
          rightSection={sectionN}
          subLabel={`Adjustments For Items Unpaid By Seller`}
        />
      )}
      {sectionCashFromBuyer && sectionCashToSeller && (
        <PurchaseFeeSection leftSection={sectionCashFromBuyer} rightSection={sectionCashToSeller} />
      )}
    </Grid>
  );
};
